'use client';
import { Typography } from '@curology/ui-components-web/react';
import React from 'react';

import { NextBoxPricing } from './nextBoxPricing';
import { type ExpressCurologySignUpSkinPdpSourceConfigType } from '../types';

export const CheckoutFooter = ({
  bundleConfig,
  selectedAddOnProductItemIds,
}: {
  bundleConfig: ExpressCurologySignUpSkinPdpSourceConfigType;
  selectedAddOnProductItemIds: number[];
}) => {
  return (
    <React.Fragment>
      <div className="cur-bg-surface-highlight cur-p-4 cur-text-brand">
        <Typography size="meta">
          Placing your order authorizes a temporary hold on your payment method.
          After your dermatology consultation is complete, your payment method
          will be charged.
        </Typography>
      </div>
      <div>
        <NextBoxPricing
          bundleConfig={bundleConfig}
          selectedAddOnProductItemIds={selectedAddOnProductItemIds}
        />
      </div>
    </React.Fragment>
  );
};
